import * as requestFromServer from "./CompanyCrud";
import { callTypes, CompanySlice } from "./CompanySlice";
import { NotificationManager } from "react-notifications";

const { actions } = CompanySlice;

export const fetchCompanyList = queryParams => dispatch => {
  dispatch(actions.emptyList());
  dispatch(actions.startCall({ callType: callTypes.list }));
  // console.log('queryParams: ', queryParams)
  return requestFromServer
    .getCompany(queryParams)
    .then(response => {
      console.log("response::fetchCompanyList ", response);
      // const { totalCount, entities } = response.data;
      const totalCount = response.totalRecord;
      const entities = response.data;
      dispatch(actions.CompanyList({ totalCount, entities }));
    })
    .catch(error => {
      const errMsg = error.response && error.response.data && error.response.data.errors ? error.response.data.errors[0].msg : error.message;
      NotificationManager.error(errMsg, 'Error');
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};



export const uploadImage = (queryParams) => dispatch => {

  return requestFromServer
    .uploadImage(queryParams.img)
    .then(response => {
      console.log("response::createUploadImage ", response);
      const uploadimage = response;
      const imageField = queryParams.name;
      dispatch(actions.uploadImage({ uploadimage, imageField }));
    })
    .catch(error => {
      console.log("error::createUploadImage ", error);
      const errMsg = error.response && error.response.data && error.response.data.errors ? error.response.data.errors[0].msg : error.message;
      NotificationManager.error(errMsg, 'Error');
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};


export const updateCompany = queryParams => dispatch => {
  return requestFromServer
    .updateCompany(queryParams)
    .then(response => {
      console.log("response::updateCompany ", response);
      const editRewardsCategory = response;
      dispatch(actions.updateCompany({ editRewardsCategory }));
    })
    .catch(error => {
      const errMsg = error.response && error.response.data && error.response.data.errors ? error.response.data.errors[0].msg : error.message;
      NotificationManager.error(errMsg, 'Error');
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const deleteCompany = queryParams => dispatch => {
  return requestFromServer
    .deleteCompany(queryParams)
    .then(response => {
      // console.log("response::deleteCompany ", response);
      NotificationManager.success('success', 'Company has been deleted successfully!');
      const deletedRewardsCategory = response;
      dispatch(actions.deleteCompany({ deletedRewardsCategory }));
    })
    .catch(error => {
      const errMsg = error.response && error.response.data && error.response.data.errors ? error.response.data.errors[0].msg : error.message;
      NotificationManager.error(errMsg, 'Error');
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const updateCompanyStatus = queryParams => dispatch => {
  return requestFromServer
    .updateCompanyStatus(queryParams)
    .then(response => {
      // console.log("response::updateCompany ", response);
      // const editRewardsCategory = response;
      NotificationManager.success('success', 'Company data updated successfully!');
      return true;
      // dispatch(actions.updateCompany({ editRewardsCategory }));
    })
    .catch(error => {
      const errMsg = error.response && error.response.data && error.response.data.errors ? error.response.data.errors[0].msg : error.message;
      NotificationManager.error(errMsg, 'Error');
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};
export const getAssignGameTypeList = companyId => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getAssignGameTypeList(companyId)
    .then((response) => {
      // console.log(response);
      return response.data;
      // dispatch(actions.itemsDeleted({ ids }));

    })
    .catch(error => {
      // error.clientMessage = "Can't delete items";
      const errMsg = error.response && error.response.data.msg;
      NotificationManager.error(errMsg, 'Error');
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};
export const getAssignGameTypeListOptimized = companyId => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getAssignGameTypeListOptimized(companyId)
    .then((response) => {
      // console.log(response);
      return response.data;
      // dispatch(actions.itemsDeleted({ ids }));

    })
    .catch(error => {
      // error.clientMessage = "Can't delete items";
      const errMsg = error.response && error.response.data.msg;
      NotificationManager.error(errMsg, 'Error');
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};
export const assignGameType = (body) => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .assignGameType(body)
    .then((response) => {
      // console.log(response);
      return response;
      // dispatch(actions.itemsDeleted({ ids }));

    })
    .catch(error => {
      // error.clientMessage = "Can't delete items";
      const errMsg = error.response && error.response.data.msg;
      NotificationManager.error(errMsg, 'Error');
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getGameLogs = (body) => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .gameLogs(body)
    .then((response) => {
      return response;
    })
    .catch(error => {
      const errMsg = error.response && error.response.data.msg;
      NotificationManager.error(errMsg, 'Error');
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const uploadGameImage = (queryParams) => dispatch => {
  return requestFromServer
    .uploadGameImage(queryParams.img)
    .then(response => {
      const entities = response.data.image;
      const imageField = queryParams.type;
      return { entities, imageField }
    })
    .catch(error => {
      console.log("error::createUploadImage ", error);
      const errMsg = error.response && error.response.data && error.response.data.errors ? error.response.data.errors[0].msg : error.message;
      NotificationManager.error(errMsg, 'Error');
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};